import { render, staticRenderFns } from "./SalesFunnelStudentList.vue?vue&type=template&id=e1236912&scoped=true"
import script from "./SalesFunnelStudentList.vue?vue&type=script&lang=js"
export * from "./SalesFunnelStudentList.vue?vue&type=script&lang=js"
import style0 from "./SalesFunnelStudentList.vue?vue&type=style&index=0&id=e1236912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1236912",
  null
  
)

export default component.exports